import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { Button } from "reactstrap";
// import Page from "../../components/Page";
import {
  isApprovedForAll,
  setApprovalForAll,
  stakeAbi,
  unstakeAbi,
} from "@bkry/bowline-components/Staking";
import {
  genericAbiRead,
  genericAbiWrite,
  mintError,
  mintingInProgressSuccess,
  transactionSuccess,
} from "@bkry/bowline-redux/contracts";
import { useSsrState } from "@issr/core";
import { useAccount } from "../../CustomHook";
/**
 * stake button container used as app default landing page
 */
const StakingButtton = (props, context) => {
  const {
    selectedTokens,
    selectTokensMode,
    handleCancelTokenSelection,
    stakingContract,
  } = props;

  const dispatch = useDispatch();
  const { account, ethProvider: provider } = useAccount();
  const [closeStakingBtn, setCloseStakingBtn] = useSsrState(false);

  const stakeOnContract = (tokens) => {
    dispatch(
      genericAbiWrite({
        functionAbi: stakeAbi,
        functionName: "stake((address,uint256)[])",
        contractAddress: stakingContract,
        account: account,
        provider: provider,
        genericInputs: {
          _tokens: tokens.map((token) => {
            return {
              contractAddress: token.address,
              tokenIdentifier: token.identifier,
            };
          }),
        },
        successCallbackFnc: (data) => {
          dispatch(mintingInProgressSuccess(data));
        },
        errorCallbackFnc: (data) => {
          dispatch(mintError(data));
          setCloseStakingBtn(true);
          handleCancelTokenSelection();
        },
        transactionCallbackFnc: (data) => {
          // toggleTransferModal();
          dispatch(transactionSuccess(data));
          setCloseStakingBtn(true);
          handleCancelTokenSelection();
        },
      })
    );
  };

  const handleStaking = async () => {
    const tokensByContract = {};
    selectedTokens.forEach((token) => {
      if (tokensByContract[token.address]) {
        tokensByContract[token.address].push(token);
      } else {
        tokensByContract[token.address] = [token];
      }
    });

    Object.keys(tokensByContract).forEach(async (contractAddress) => {
      dispatch(
        genericAbiRead({
          functionAbi: isApprovedForAll,
          contractAddress,
          account: account,
          provider: provider,
          genericInputs: {
            owner: account,
            operator: stakingContract,
          },
          successCallbackFnc: (data) => {
            if (data) {
              stakeOnContract(tokensByContract[contractAddress]);
            } else {
              dispatch(
                genericAbiWrite({
                  functionAbi: setApprovalForAll,
                  contractAddress,
                  account: account,
                  provider: provider,
                  genericInputs: {
                    operator: stakingContract,
                    approved: true,
                  },
                  successCallbackFnc: (data) => {
                    dispatch(mintingInProgressSuccess(data));
                  },
                  errorCallbackFnc: (data) => {
                    dispatch(mintError(data));
                  },
                  transactionCallbackFnc: (data) => {
                    // toggleTransferModal();
                    dispatch(transactionSuccess(data));
                    stakeOnContract(tokensByContract[contractAddress]);
                  },
                })
              );
            }
          },
          errorCallbackFnc: (data) => {
            console.error("error Data", data);
          },
        })
      );
    });
  };

  const handleUnstaking = async () => {
    dispatch(
      genericAbiWrite({
        functionAbi: unstakeAbi,
        contractAddress: stakingContract,
        functionName: "unstake((address,uint256)[])",
        account: account,
        provider: provider,
        genericInputs: {
          _tokens: selectedTokens.map((token) => {
            return {
              contractAddress: token.address,
              tokenIdentifier: token.identifier,
            };
          }),
        },
        successCallbackFnc: (data) => {
          dispatch(mintingInProgressSuccess(data));
        },
        errorCallbackFnc: (data) => {
          dispatch(mintError(data));
          setCloseStakingBtn(true);
          handleCancelTokenSelection();
        },
        transactionCallbackFnc: (data) => {
          // toggleTransferModal();
          dispatch(transactionSuccess(data));
          setCloseStakingBtn(true);
          handleCancelTokenSelection();
        },
      })
    );
  };

  return (
    !closeStakingBtn && (
      <div className="my-3 d-grid gap-2 col-sm-12 col-lg-6 mx-auto">
        <Button
          className=""
          color="primary"
          onClick={
            selectTokensMode === "stake" ? handleStaking : handleUnstaking
          }
        >
          {selectTokensMode === "stake"
            ? context.t("Stake All selected")
            : context.t("Unstake All selected")}
        </Button>
        <Button
          className="fw-bold"
          color="danger"
          outline
          onClick={handleCancelTokenSelection}
        >
          {context.t("Cancel")}
        </Button>
      </div>
    )
  );
};

/**  define proptype for the 'translation' function  */
StakingButtton.contextTypes = {
  t: PropTypes.func,
};

StakingButtton.propTypes = {
  tokenIdentifier: PropTypes.string.isRequired,
  contractAddress: PropTypes.string,
  isStaked: PropTypes.bool,
  setStakeBtnClicked: PropTypes.func,
  selectedTokens: PropTypes.array,
  selectTokensMode: PropTypes.string,
  handleCancelTokenSelection: PropTypes.func,
  stakingContract: PropTypes.string,
};

/** export the component as redux connected component */
export default StakingButtton;
